export function formatReplyRatePercent(replyRate: number): string {
  return `${(replyRate * 100).toFixed(replyRate > 0 && replyRate < 0.1 ? 1 : 0)}%`;
}

export function formatReplyRateHint(
  customersReplied: number,
  customersEmailed: number,
): string {
  return `${customersReplied} of ${customersEmailed} customers replied`;
}
